import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../../../../common/state';
import { EFacility } from '../../../../../../../json_query';
import { changeFacility } from '../../../../../../state/advanced/facilities';
import { facilitiesFromJsonQuery } from '../../../../../../../utils/facilities';
import { LivingTermsComponent } from './livingTerms';

export function mapStateToProps(state: IAppState) {
  return {
    facilities: facilitiesFromJsonQuery(state.filters.jsonQuery),
  };
}

export function mapDispatchToProps(dispatch: Dispatch) {
  return {
    onFacilityChanged: (param: EFacility, value: boolean) => {
      dispatch(changeFacility(param, value));
    },
  };
}

export const LivingTerms = connect(mapStateToProps, mapDispatchToProps)(LivingTermsComponent);
